import { useNavigate } from "react-router-dom";

function HoverNavButton({text, width, link, img, hoverImg, height}){
    const navigate = useNavigate();

    return(
        <div className="HoverNavButton" style={{width: width, height: height, backgroundImage: `url(${img})`, "--hover-img": `url(${hoverImg})`}} onClick={() => navigate(link)}>
            <p>{text}</p>
        </div>
    );
}
export default HoverNavButton;